import React, { useState, useEffect } from "react";

// props expected
// size: sm / md / lg
// direction: right / left

export default function SlideBar(props) {
    useEffect(() => {
        if(props.isEnabled) {
            $(document).on('click', '.slidebar-overlay', function (e) {
                if ($(e.target).closest('.slide-bar-toggle, .slide-bar').length > 0 || $(e.target).hasClass('toggle-slidebar')) return;
                onClose();
            });
            document.body.classList.add('overflow-hidden');
        }
    });

    useEffect(() => {
        if(!props.isEnabled) {
            document.body.classList.remove('overflow-hidden');
        }
    }, [props.isEnabled])

    const onClose = () => {
        props.toggleSlideBar();
    }

    return (
        <div className={`${props.isEnabled ? 'slide-bar-enabled' : ''}`}>
            <div className={`slidebar-overlay`}/>
            <div className={`slide-bar slide-bar-${props.direction}-${props.size} slide-bar-${props.size}`} style={{height: '100vh'}}>
                <div className={'h-100'}>
                    <div className={'simplebar-wrapper'}>
                        <div className={'simplebar-height-auto-observer-wrapper'}>
                            <div className={'simplebar-height-auto-observer'}>

                            </div>
                        </div>

                        <div className={'simplebar-mask'}>
                            <div className={'simplebar-offset'}>
                                <div className={'simplebar-content-wrapper'}>
                                    <div className={'simplebar-content overflow-hidden h-100 position-relative'}>
                                        <div className={'position-absolute'} style={{right: '0', zIndex: 10, cursor: 'pointer'}}>
                                            <i onClick={onClose} className="fal fa-times fs-5 m-2"></i>
                                        </div>
                                        {props.children}
                                    </div>
                                </div>
                            </div>
                            <div className={'simplebar-placeholder'}>

                            </div>
                        </div>
                    </div>

                    <div className={'simplebar-track simplebar-horizontal'}>
                        <div className={'simplebar-scrollbar'}></div>
                    </div>

                    <div className={'simplebar-track simplebar-vertical'}>
                        <div className={'simplebar-scrollbar'}></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

